const notifyPurchaseStatusChange = {
  "type": "webhook",
  "method": "post",
  "title": "Notify Purchase Status Change",
  "description": "Notification sent to your webhook endpoint when the status of a purchase draft changes",
  "request": {
    "headers": [
      {
        "key": "key-hash",
        "required": true,
        "type": "string",
        "description": "sha256 hash of your api key",
        "example": "5e884898da28047151d0e56f8dc6292773603d0d6aabbdd62a11ef721d1542d8"
      }
    ]
  },
  "payload": {
    "$ref": "#/components/schemas/PurchaseStatusChangeWebhookPayload"
  },
  "components": {
    "schemas": {
      "PURCHASE_STATUS": {
        "description": "Possible values: pending, paid, cancelled, refunded.",
        "type": "string",
        "enum": [
          "pending",
          "paid",
          "cancelled",
          "refunded"
        ]
      },
      "PurchaseStatusChangeWebhookPayload": {
        "type": "object",
        "properties": {
          "draft_id": {
            "type": "string",
            "description": "ID of the purchase draft",
            "example": "lX8RkQmK49iPVWRt9gdc"
          },
          "status": {
            "$ref": "#/components/schemas/PURCHASE_STATUS",
            "description": "New status of the purchase Possible values: pending, paid, cancelled, refunded.",
            "example": "paid"
          },
          "paid_at": {
            "type": "number",
            "description": "Timestamp when the purchase was paid, or null if not paid",
            "example": 1672531199000
          },
          "cancelled_at": {
            "type": "number",
            "description": "Timestamp when the purchase was cancelled, or null if not cancelled",
            "example": 1672531199000
          }
        },
        "required": [
          "draft_id",
          "status"
        ]
      },
      "PartnerWebhookRequestHeaders": {
        "type": "object",
        "properties": {
          "key-hash": {
            "type": "string",
            "description": "sha256 hash of your api key",
            "example": "5e884898da28047151d0e56f8dc6292773603d0d6aabbdd62a11ef721d1542d8"
          }
        },
        "required": [
          "key-hash"
        ]
      }
    }
  }
}

export { notifyPurchaseStatusChange }
